export default "__VITE_ASSET__X$yr5cFo__"